exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fecha[data-v-08b6bcdc]{margin-top:10px;margin-left:2px}.box-sub[data-v-08b6bcdc]{height:118px!important}.fecha table[data-v-08b6bcdc]{justify-content:end}.is-blue[data-v-08b6bcdc]{background-color:#a8c2ef!important;color:#fff!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-08b6bcdc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cultura/Resultadoscultura.vue
// module id = 1086
// module chunks = 2